/**
 * Personnel Service Layer - Business logic + Mock adapter
 */

import { config } from '../../config';
import * as personnelMock from '../../mocks/personnel';
import httpClient from '../httpClient';
import { API_ENDPOINTS } from '../../utils/apiEndpoints';

/**
 * Query personnel levels (paged)
 */
export async function pagePersonnelLevels(params) {
  if (config.mock) {
    return personnelMock.mockPagePersonnelLevels(params);
  }
  return httpClient.post(API_ENDPOINTS.PERSONNEL.PAGE_LEVELS, params);
}

/**
 * Create personnel level
 */
export async function createPersonnelLevel(data) {
  if (config.mock) {
    return personnelMock.mockCreatePersonnelLevel(data);
  }
  return httpClient.post(API_ENDPOINTS.PERSONNEL.CREATE_LEVEL, data);
}

/**
 * Update personnel level
 */
export async function updatePersonnelLevel(data) {
  if (config.mock) {
    return personnelMock.mockUpdatePersonnelLevel(data);
  }
  return httpClient.post(API_ENDPOINTS.PERSONNEL.UPDATE_LEVEL, data);
}

/**
 * Delete personnel level
 */
export async function deletePersonnelLevel(id) {
  if (config.mock) {
    return personnelMock.mockDeletePersonnelLevel(id);
  }
  return httpClient.post(API_ENDPOINTS.PERSONNEL.DELETE_LEVEL, { id });
}

/**
 * Query personnel for binding (paged) - uses store-scoped account query
 */
export async function queryPersonnel(params) {
  if (config.mock) {
    return personnelMock.mockQueryPersonnel(params);
  }
  return httpClient.post(API_ENDPOINTS.ACCOUNT.STORE_ACCOUNTS, params);
}

/**
 * Get bound personnel IDs for a level
 */
export async function getBoundPersonnel(levelId) {
  if (config.mock) {
    return personnelMock.mockGetBoundPersonnel(levelId);
  }
  return httpClient.post(API_ENDPOINTS.PERSONNEL.GET_BOUND, { levelId });
}

/**
 * Bind personnel to a level
 */
export async function bindPersonnel(data) {
  if (config.mock) {
    return personnelMock.mockBindPersonnel(data);
  }
  return httpClient.post(API_ENDPOINTS.PERSONNEL.BIND, data);
}

/**
 * Get order complexity configuration
 */
export async function getOrderComplexityConfig() {
  if (config.mock) {
    return personnelMock.mockGetOrderComplexityConfig();
  }
  return httpClient.post(API_ENDPOINTS.PERSONNEL.GET_ORDER_COMPLEXITY);
}

/**
 * Update order complexity configuration
 */
export async function updateOrderComplexityConfig(data) {
  if (config.mock) {
    return personnelMock.mockUpdateOrderComplexityConfig(data);
  }
  return httpClient.post(API_ENDPOINTS.PERSONNEL.UPDATE_ORDER_COMPLEXITY, data);
}
